import type { MatchingItem } from '@vedalib/editor/lib/elements'
import { useMemo } from 'react'

import { shuffle } from 'utils/shuffle'

import type { MatchingGroups, TestMatchingStateType } from './testMatchingTypes'

export const mapElements = (
  items: MatchingItem[],
  side: 'left' | 'right' = 'left',
): MatchingGroups[] => {
  return items.map((item) => ({
    value: item.value,
    isActive: false,
    label: side === 'left' ? item.leftLabel : item.rightLabel,
  }))
}

export const useGetLeftRightItems = (
  isViewMode: boolean,
  items: MatchingItem[],
  elementState?: TestMatchingStateType,
) => {
  // shuffle elements only on first mount(we haven`t elementState yet) and only in view(preview)
  const { left, right } = useMemo((): { left: MatchingGroups[]; right: MatchingGroups[] } => {
    if (isViewMode) {
      if (!elementState?.value && elementState?.initialItems) {
        return {
          left: elementState.initialItems,
          right: mapElements(items || [], 'right'),
        }
      }

      if (!elementState?.value) {
        return {
          left: shuffle(mapElements(items || [])),
          right: mapElements(items || [], 'right'),
        }
      }

      return {
        left: elementState.shuffledItems || [],
        right: mapElements(items || [], 'right'),
      }
    }
    return {
      left: mapElements(items || []),
      right: mapElements(items || [], 'right'),
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [elementState, items])
  return { left, right }
}

export const useGetSize = (
  state: { width: number; height: number },
  wrapperRef: React.MutableRefObject<HTMLDivElement | null>,
  items: MatchingItem[],
  paddings: number,
) => {
  const width = state?.width || 200
  const height = useMemo(() => {
    if (state.width && wrapperRef.current) {
      const els = wrapperRef.current.querySelectorAll('#itemWrapper')
      if (els) {
        return (
          Array.from(els).reduce((res, e) => {
            const content = e.querySelector('#itemContent')
            if (content) {
              const rec = content.getBoundingClientRect()
              if (rec.height > res) {
                return rec.height
              }
            }
            return res
          }, 0) + paddings
        )
      }
    }
    return
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.width, wrapperRef, items, paddings])
  return { width, height }
}
